<template>
  <div>
    <hg-dialog title="新增机构" :width="700" :height="400" :visible="dialogVisible" @close="handleClose">
      <el-form :model="data" size="mini"  :rules="rules" ref="ruleForm" label-width="110px" class="add-box">
        <el-row :gutter="22">
          <el-col :span="22">
            <el-form-item label="上级机构" prop="parentId">
              <organizational-select @handleChange="handleChange" :selectedArr="selectedArr" v-if="dialogVisible" selectType="save"></organizational-select>
              <!--<el-input v-model="data.parentId" maxlength="50" placeholder="请选择上级机构"></el-input>-->
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="22">
          <el-col :span="11">
            <el-form-item label="机构编码" prop="depCode">
              <el-input v-model="data.depCode" maxlength="12" placeholder="请输入机构编码"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="机构名称" prop="name">
              <el-input v-model="data.name" maxlength="50" placeholder="请输入机构名称"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="22">
          <el-col :span="11">
            <el-form-item label="机构简称" prop="shortname">
              <el-input v-model="data.shortname" maxlength="50" placeholder="请输入机构简称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="联系方式1" prop="phone1">
              <el-input v-model="data.phone1" maxlength="11" placeholder="请输入联系方式1"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="22">
          <el-col :span="11">
            <el-form-item label="机构级别" prop="grade">
              <el-select v-model="data.grade" placeholder="请选择机构级别">
                <el-option v-for="(item,index) in 9" :key="index" :label="index+1+'级'" :value="index+1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="联系方式2" prop="phone2">
              <el-input v-model="data.phone2" maxlength="11" placeholder="请输入联系方式2"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="22">
          <el-col :span="11">
            <el-form-item label="排序号" prop="sort">
              <el-input v-model="data.sort" maxlength="8" placeholder="请输入排序号"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="查询前缀" prop="before">
              <el-input v-model="data.before" maxlength="50" placeholder="请输入查询前缀"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="hg-dialog-footer">
        <el-button type="primary" @click="submit" size="small" icon="el-hg-icon-save">保 存</el-button>
        <el-button @click="handleClose" size="small" icon="el-hg-icon-close">关 闭</el-button>
      </span>
    </hg-dialog>
  </div>
</template>
<script>
import organizationalSelect from '../../../comm/organizationalSelect';
import HgDialog from '@/components/dialog';

export default {
  name: 'add',
  components: {
    organizationalSelect,
    HgDialog
  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogVisible: false,
      rules: {
        parentId: [{
          required: true,
          message: '请选择上级部门',
          trigger: 'blur'
        }],
        depCode: [{
          required: true,
          message: '请输入机构编码',
          trigger: 'blur'
        }],
        name: [{
          required: true,
          message: '请输入机构名称',
          trigger: 'blur'
        }],
        shortname: [{
          required: true,
          message: '请输入机构简称',
          trigger: 'blur'
        }],
        phone1: [
          {
            required: true,
            message: '请输入联系方式1',
            trigger: 'blur'
          },
          {
            pattern: this.$utils.regRule.phone,
            message: '联系方式格式不正确',
            trigger: 'blur'
          }
        ],
        grade: [{
          required: true,
          message: '请选择机构级别',
          trigger: 'change'
        }],
        // phone2: [
        //   { required: true, message: '请输入联系方式2', trigger: 'blur' },
        //   { pattern: this.$utils.regRule.phone, message: '联系方式格式不正确', trigger: 'blur' }
        // ],
        sort: [
          {
            required: true,
            message: '请输入排序号',
            trigger: 'blur'
          },
          {
            pattern: this.$utils.regRule.nGInteger,
            message: '排序号格式不正确',
            trigger: 'blur'
          }
        ],
        before: [{
          required: true,
          message: '请输入查询前缀',
          trigger: 'blur'
        }]
      },
      data: {
        parentId: '',
        depCode: '',
        name: '',
        shortname: '',
        phone1: '',
        grade: '',
        phone2: '',
        sort: '',
        before: '',
        updateFlg: 'add'
      },
      selectedArr: []
    };
  },
  methods: {
    submit() {
      this.$refs['ruleForm'].validate(valid => {
        if (valid) {
          this.saveDepart();
        }
        else {
          return false;
        }
      });
    },
    handleChange(arry) {
      this.data.parentId = arry.join(',');
    },
    async saveDepart() {
      const res = await this.$services.postJson({
        type: 'ORGANIZATIONALMANAGEMENT',
        url: 'saveDepart',
        params: JSON.parse(JSON.stringify(this.data))
      });
      if (res.code === '000') {
        this.$toaster.ok('保存成功');
        this.handleClose();
        this.$emit('addKeyChildren');
      }
      else {
        this.$toaster.error(res.msg);
      }
    },
    handleClose() {
      // this.$refs['ruleForm'].resetFields();
      this.dialogVisible = false;
      this.$emit('close');
    }
  },
  watch: {
    show(val) {
      if (val) {
        this.dialogVisible = true;
      }
    }
  }
};
</script>
<style lang="scss">
@import '@/assets/css/addEditForm.scss';
</style>
